import {apiEnvironment} from '../smoothr-web-app-core/environments/apiEnvironment';

export const eamCustomerGroup = 'eam';
export const customerGroup = eamCustomerGroup;

const supportEmail = {
	eam: 'eam@smoothr.de'
};
const firebaseConfig = {
	eam: {
		apiKey: 'AIzaSyBgQ_LSUpazFB09uhSYSrvdp6A6XVUVQGQ',
		authDomain: 'eam-outlet.firebaseapp.com',
		projectId: 'eam-outlet',
		storageBucket: 'eam-outlet.appspot.com',
		messagingSenderId: '415039699499',
		appId: '1:415039699499:web:389f9b1ca29232b4f8886e',
		measurementId: 'G-XZW54S4HHX'
	}
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDnab1vzKZ5CtajeMRi14rSYgEvphqgkro',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	...apiEnvironment,
	countryList: ['de'],
	gaId: '',
	urlQrCode: 'smoothr://order/'
};

import 'zone.js/dist/zone-error';
